export function formatDate(
  str,
  options = { year: "numeric", month: "numeric", day: "numeric" }
) {
  if (!str) return "";
  return new Date(str).toLocaleDateString("pt-BR", options);
}
